import { render, staticRenderFns } from "./AccountError.vue?vue&type=template&id=ba52bb8c&"
import script from "./AccountError.vue?vue&type=script&lang=js&"
export * from "./AccountError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports